var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Slice") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "profile.portfolio",
    transform: "translate(-666.000000, -927.000000)",
    fill: "#F63D3D"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(354.000000, 573.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "general/warning",
    transform: "translate(312.000000, 354.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 0.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.71838924,0.196320873 C6.94087466,0.32477289 7.12562818,0.509526408 7.2540802,0.732011829 L11.7771671,8.56622811 C12.1813111,9.26622606 11.9414741,10.16131 11.2414761,10.565454 C11.0189907,10.693906 10.7666127,10.7615305 10.5097087,10.7615305 L1.46353491,10.7615305 C0.655246898,10.7615305 1.77635684e-14,10.1062836 1.77635684e-14,9.29799556 C1.77635684e-14,9.04109153 0.0676244811,8.78871353 0.196076499,8.56622811 L4.71916338,0.732011829 C5.12330738,0.0320138775 6.01839129,-0.207823133 6.71838924,0.196320873 Z M5.98663419,8.33526502 C5.64984752,8.33526502 5.37682798,8.60828457 5.37682798,8.94507124 C5.37682798,9.28185791 5.64984752,9.55487745 5.98663419,9.55487745 C6.32342086,9.55487745 6.59644041,9.28185791 6.59644041,8.94507124 C6.59644041,8.60828457 6.32342086,8.33526502 5.98663419,8.33526502 Z M5.98663419,2.19415776 C5.97071491,2.19415776 5.95479906,2.19462609 5.93890732,2.19556213 C5.49140087,2.22192096 5.14999326,2.60606466 5.17635209,3.05357111 L5.17635209,3.05357111 L5.42230689,7.22926412 C5.43990555,7.52804513 5.68733534,7.76132977 5.98663419,7.76132977 C6.28593305,7.76132977 6.53336284,7.52804513 6.5509615,7.22926412 L6.5509615,7.22926412 L6.7969163,3.05357111 L6.7969163,3.05357111 L6.79832068,3.00584424 C6.79832068,2.55756217 6.43491626,2.19415776 5.98663419,2.19415776 Z",
    id: "Combined-Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.69b1b2efaa10847cbcfcce87a8835c26.svg";
export { ForwardRef as ReactComponent };